import React from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Fui a barberías al azar durante años. La primera vez en Barbershop Delux Cut entendí lo que me había perdido. Estos muchachos realmente se preocupan por el resultado.',
    name: 'Cliente Verificado'
  }, {
    quote: 'El mejor fade que me he hecho en la vida. Punto. El ambiente solo ya vale la pena — ahora en realidad espero mis citas con ganas.',
    name: 'Cliente Verificado'
  }, {
    quote: 'Entré sintiéndome como un martes cualquiera. Salí sintiéndome como si tuviera algún lugar importante a donde ir. Esa es la diferencia.',
    name: 'Cliente Verificado'
  }];
  return <section id="testimonios" className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-335">
      <div className="max-w-6xl mx-auto" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-337">
          <TrophyIcon className="w-12 h-12 text-delux-gold mx-auto mb-6" data-id="element-338" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-339">
            Lo Que Dicen Nuestros Clientes
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-340">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-delux-card p-8 rounded-lg border border-delux-gold/20 relative flex flex-col h-full" data-id="element-341">
              <QuoteIcon className="w-10 h-10 text-delux-gold/20 absolute top-6 left-6" data-id="element-342" />

              <div className="flex space-x-1 mb-6 relative z-10" data-id="element-343">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-delux-gold fill-delux-gold" data-id="element-344" />)}
              </div>

              <p className="font-body text-delux-body text-lg italic mb-8 relative z-10 flex-grow" data-id="element-345">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-delux-gold/20 pt-4 mt-auto" data-id="element-346">
                <p className="font-heading text-delux-white font-bold tracking-wide uppercase text-sm" data-id="element-347">
                  {testimonial.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
      <Divider data-id="element-348" />
    </section>;
}